import { InternalAxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';

import config from 'config';
import { getRecaptchaToken } from 'core/services';

import { axiosClient } from '../../client';

import type { AuthCredentials, DataAuthPayload } from 'core/domains/auth';

export async function login(user: AuthCredentials): Promise<DataAuthPayload> {
  const recaptchaToken = await getRecaptchaToken(user.username, 'login');

  Cookies.set('X-Recaptcha-Token', recaptchaToken || '');

  axiosClient.interceptors.request.use(embbedRecaptchaKeys);

  return axiosClient.post('auth', user);
}

export function embbedRecaptchaKeys(request: InternalAxiosRequestConfig) {
  const {
    google: { recaptcha },
  } = config;

  request.headers['x-rc-authorization'] = Cookies.get('X-Recaptcha-Token');
  request.headers['x-rc-sitekey'] = recaptcha.secretKey;

  return request;
}
